var render = function render(){var _vm=this,_c=_vm._self._c;return _c('node-view-wrapper',{staticClass:"add-transparent-border"},[_c('vuetify-audio',{staticClass:"audio-wrapper",attrs:{"file":_vm.node.attrs.file,"color":_vm.node.attrs.color,"pathaudio":_vm.node.attrs.pathAudio,"flat":"","type":_vm.node.attrs.type,"title":_vm.node.attrs.title}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }